import { DateService } from 'outshared-lib';

export class AllowedAgeUtility {

    public isNotAllowed(birthdate: string): boolean {
        const ALLOWED_AGE = 23;
        const age = this.calculateAge(birthdate);

        return Boolean(age < ALLOWED_AGE);
    }

    private calculateAge(date: string): number {
        const dateService = new DateService();
        const birthdate = dateService.fromString(date, 'YYYY-MM-DD');
        const birthdateObject = dateService.dateAsObject(birthdate);

        return dateService.calculateAge({
            year: birthdateObject.year(),
            month: birthdateObject.month(),
            day: birthdateObject.date(),
        });
    }
}
